var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-sidebar",class:{
    'the-sidebar--loading': _vm.isLoading,
    'the-sidebar--sticky': _vm.isSticky,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }